// time constants (ms)
export const SAVE_TO_LOCAL_STORAGE_TIMEOUT = 300;
export const INITIAL_SCENE_UPDATE_TIMEOUT = 5000;
export const FILE_UPLOAD_TIMEOUT = 300;
export const LOAD_IMAGES_TIMEOUT = 500;
export const SYNC_FULL_SCENE_INTERVAL_MS = 20000;
export const SYNC_BROWSER_TABS_TIMEOUT = 50;
export const CURSOR_SYNC_TIMEOUT = 33; // ~30fps
export const DELETED_ELEMENT_TIMEOUT = 24 * 60 * 60 * 1000; // 1 day

// should be aligned with MAX_ALLOWED_FILE_BYTES
export const FILE_UPLOAD_MAX_BYTES = 4 * 1024 * 1024; // 4 MiB
export const WS_EVENTS = {
  SERVER_VOLATILE: "server-volatile-broadcast",
  SERVER: "server-broadcast",
  USER_FOLLOW_CHANGE: "user-follow",
  USER_FOLLOW_ROOM_CHANGE: "user-follow-room-change",
} as const;

export enum WS_SUBTYPES {
  INVALID_RESPONSE = "INVALID_RESPONSE",
  INIT = "SCENE_INIT",
  UPDATE = "SCENE_UPDATE",
  MOUSE_LOCATION = "MOUSE_LOCATION",
  IDLE_STATUS = "IDLE_STATUS",
  USER_VISIBLE_SCENE_BOUNDS = "USER_VISIBLE_SCENE_BOUNDS",
}

export const ROOM_ID_BYTES = 10;

export const STORAGE_KEYS = {
  LOCAL_STORAGE_ELEMENTS: "drawink",
  LOCAL_STORAGE_APP_STATE: "drawink-state",
  LOCAL_STORAGE_COLLAB: "drawink-collab",
  LOCAL_STORAGE_THEME: "drawink-theme",
  LOCAL_STORAGE_DEBUG: "drawink-debug",
  VERSION_DATA_STATE: "version-dataState",
  VERSION_FILES: "version-files",
  LOCAL_STORAGE_BOARDS: "drawink-boards",
  LOCAL_STORAGE_CURRENT_BOARD_ID: "drawink-current-board-id",

  IDB_LIBRARY: "drawink-library",

  // Cloud sync keys
  LOCAL_STORAGE_USER: "drawink-user",
  LOCAL_STORAGE_WORKSPACES: "drawink-workspaces",
  LOCAL_STORAGE_CURRENT_WORKSPACE_ID: "drawink-current-workspace-id",
  LOCAL_STORAGE_SYNC_STATE: "drawink-sync-state",
  LOCAL_STORAGE_AUTH_STATE: "drawink-auth-state",

  // do not use apart from migrations
  __LEGACY_LOCAL_STORAGE_LIBRARY: "drawink-library",
} as const;

export const COOKIES = {
  AUTH_STATE_COOKIE: "excplus-auth",
} as const;

export const isDrawinkPlusSignedUser = document.cookie.includes(COOKIES.AUTH_STATE_COOKIE);
